"use client"
import React, { useState } from 'react';
import styles from './ShareBanner.module.scss';
import { pushToDataLayer } from '@/helpers/gtag';
import { getGlobalStateValue } from '@/context/utils';
import CopiedSVG from '@/SvgIcons/CopyIcon';

const socialLinks = [
    { name: "whatsapp", icon: "https://imagicom.in/design/mba-social3/images/whatsapp.png", link: "https://api.whatsapp.com/send?text=" },
    { name: "linkedIn", icon: "https://imagicom.in/design/mba-social3/images/linkedin.png", link: "https://www.linkedin.com/sharing/share-offsite/?url=" },
    { name: "facebook", icon: "https://imagicom.in/design/mba-social3/images/facebook.png", link: "https://www.facebook.com/sharer/sharer.php?u=" },
    { name: "x", icon: "https://imagicom.in/design/mba-social3/images/twitter.png", link: "https://twitter.com/intent/tweet?&url=" },
    { name: "mail", icon: "https://imagicom.in/design/mba-social3/images/mail.png", link: "mailto:?body=" },
    { name: "sms", icon: "https://imagicom.in/design/mba-social3/images/message.png", link: "sms:?body=",onlyMobile:true },
];

const ShareBanner = ({isMobile,programTitle}) => {
    const referralLink = window.location.href;
    const [isCopied,setIsCopied] = useState(false);

    const handleCopy = () => {
        try {
            navigator.clipboard.writeText(referralLink);
            setIsCopied(true)
            setTimeout(()=>{
            setIsCopied(false);
            },3000)
            setTimeout(() => {
                pushToDataLayer({
                  event: "copy_url",
                  cta_text: "Copy",
                  section_name: "hero_banner",
                  page_type: getGlobalStateValue("pageType"),
                  page_url: location.href,
                  header_title:programTitle,
                });
              }, 2500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const handleGAEvent = (socialName: string) => {
        setTimeout(() => {
             pushToDataLayer({
               event: `share_initiate_${socialName}`,
               cta_text: `${socialName} Share`,
               section_name: "hero_banner",
               page_type: getGlobalStateValue("pageType"),
               page_url: location.href,
               header_title:programTitle,
             });
           }, 2500);
    };

    return (
        <section aria-labelledby="share-title" className={styles.shareContainer}>
            <h1 id="share-title" className={styles.shareTitle}>Share this program</h1>

            <div className={styles.shareLinkContainer}>
                <p className={styles.shareLinkText}>{referralLink}</p>
                <button disabled={isCopied} onClick={handleCopy} className={`${styles.copyButton} ${isCopied ? styles.disabled : ''}`}>
                    {!isCopied && <CopiedSVG/>}
                    <span>{isCopied?'Copied':'Copy'}</span>
                </button>
            </div>

            <div className={styles.socialLinks}>
                {socialLinks.map((social) => (
                    (!social.onlyMobile || (social.onlyMobile && isMobile)) && (
                    <a
                        key={social.name}
                        href={`${social.link}${referralLink}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialButton}
                        aria-label={`Share on ${social.name}`}
                        onClick={() => handleGAEvent(social.name)}
                    >
                        <img className={styles.socialIcon} src={social.icon} alt={`${social.name} icon`} />
                    </a>
                    )
                ))}
            </div>
        </section>
    );
};

export default ShareBanner;